import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

export const TractSellerOrder = () => {
  const [ProductUser, setProductUser] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [showReasonModal, setShowReasonModal] = useState(false);
  const [selectedReason, setSelectedReason] = useState("");
  const [showReapplyModal, setShowReapplyModal] = useState(false);
const [selectedProductId, setSelectedProductId] = useState(null);



  const navigate = useNavigate();
  const sellerId = localStorage.getItem("seller_id");


  // PAGINATION
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = ProductUser.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(ProductUser.length / itemsPerPage);

  const paginate = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  // ===================== FETCH ALL DATA =====================
  useEffect(() => {
    const fetchAll = async () => {
      try {
        const sellerId = localStorage.getItem("seller_id");

        if (!sellerId) {
          toast.error("Seller not logged in");
          navigate("/login");
          return;
        }

        // Categories
        const catRes = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_category"
        );
        if (catRes.data.status === true) {
          setCategories(catRes.data.row);
        }

        // Subcategories
        const subRes = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_subcategory"
        );
        if (subRes.data.status === "true") {
          setSubcategories(subRes.data.row);
        }

        // 🔥 Products by Seller ID
        const formData = new FormData();
        formData.append("seller_id", sellerId);

        const prodRes = await axios.post(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/create_get_product_by_id",
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        if (prodRes.data.status === true) {
          setProductUser(prodRes.data.data || []);
        } else {
          setProductUser([]);
          toast.error("No products found for this seller");
        }
      } catch (error) {
        console.error("Fetch error:", error);
        toast.error("Error fetching seller products");
      }
    };

    fetchAll();
  }, []);


  // Convert Category ID → Name
  const getCategoryName = (id) => {
    const category = categories.find((c) => String(c.category_id) === String(id));
    return category ? category.category_name : "-";
  };

  // Convert Subcategory ID → Name
  const getSubCategoryName = (id) => {
    const sub = subcategories.find((s) => String(s.subcategory_id) === String(id));
    return sub ? sub.subcategory_name : "-";
  };

  // ===================== DELETE PRODUCT =====================
  const deleteUser = async (userId) => {
    const formData = new FormData();
    formData.append("product_id", userId);

    try {
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/delete_create_product",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (response.data.status === "true" || response.data.status === true) {
        setProductUser((prev) =>
          prev.filter((user) => user.product_id !== userId)
        );
        toast.error(response.data.message || "Product deleted successfully!");
      } else {
        toast.error(response.data.message || "Delete failed.");
      }
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Failed to delete product.");
    }
  };

  const handleReapply = async (productId) => {
  try {
    const formData = new FormData();
    formData.append("product_id", productId);
    formData.append("admin_approval", "Reapplied");

    const res = await axios.post(
      "https://cyberathon.com/multivendor/index.php/Api/Master_controller/update_create_product",
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    if (res.data.status === "true") {
      toast.success("Product reapplied successfully");

      // Update UI instantly
      setProductUser((prev) =>
        prev.map((item) =>
          item.product_id === productId
            ? { ...item, admin_approval: "Reapplied" }
            : item
        )
      );

      // Optional: redirect to edit page
      navigate(`/product-edit/${productId}`);
    } else {
      toast.error(res.data.message || "Reapply failed");
    }
  } catch (error) {
    console.error("Reapply error:", error);
    toast.error("Something went wrong while reapplying");
  }
};


  const openReasonModal = (reason) => {
    setSelectedReason(reason || "No reason provided");
    setShowReasonModal(true);
  };

  const closeReasonModal = () => {
    setShowReasonModal(false);
    setSelectedReason("");
  };


  // ===================== STATUS HANDLING FIX =====================
  const getStatusUI = (statusValue) => {
    let text = "Out of Stock";
    let css = "bg-danger-subtle text-danger";

    if (statusValue === "In Stock") {
      text = "In Stock";
      css = "bg-success-subtle text-success";
    }
    if (statusValue === "Few Left") {
      text = "Few Left";
      css = "bg-warning-subtle text-warning";
    }

    return { text, css };
  };


  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* PAGE TITLE */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Product List</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="#">Product</Link>
                </li>
                <li className="breadcrumb-item active">Product List</li>
              </ol>
            </div>
          </div>
        </div>

        {/* TABLE SECTION */}
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header d-flex flex-wrap justify-content-between align-items-center gap-1">
                <h4 className="card-title flex-grow-1">All Product List</h4>
                {/* <Link to="/product-add" className="btn btn-sm btn-primary">
                  Add Product
                </Link> */}
              </div>

              <div>
                <div className="table-responsive">
                  <table className="table align-middle mb-0 table-hover table-centered">
                    <thead className="bg-light-subtle">
                      <tr>
                        <th style={{ width: 20 }}>
                          <div className="form-check ms-1 fs-16">
                            <input type="checkbox" className="form-check-input" />
                          </div>
                        </th>
                        <th>Product Name & Size</th>
                        <th>Product Category</th>
                        <th>Sub Category</th>
                        {/* <th>Current Price</th>
                        <th>Old Price</th>
                        <th>Stock</th>
                        <th>Rating</th>
                        <th>Vendor</th> */}
                        <th>Status</th>

                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {currentItems.length > 0 ? (
                        currentItems.map((user) => {
                          const statusData = getStatusUI(user.status);

                          return (
                            <tr key={user.product_id}>
                              <td>
                                <div className="form-check ms-1 fs-16">
                                  <input type="checkbox" className="form-check-input" />
                                </div>
                              </td>

                              {/* PRODUCT IMAGE + NAME */}
                              <td>
                                <div className="d-flex align-items-center gap-2">
                                  <div className="rounded bg-light avatar-md d-flex align-items-center justify-content-center">
                                    <img
                                      src={
                                        user.multi_image && user.multi_image.length > 0
                                          ? `https://cyberathon.com/multivendor/${user.multi_image[0]}`
                                          : "https://via.placeholder.com/80x80?text=No+Image"
                                      }
                                      alt={user.product_name}
                                      className="avatar-md"
                                    />
                                  </div>

                                  <div>
                                    <span className="text-dark fw-medium fs-15">
                                      {user.product_name || "N/A"}
                                    </span>
                                    <p className="text-muted mb-0 mt-1 fs-13">
                                      Size: {user.available_size || "N/A"}
                                    </p>
                                  </div>
                                </div>
                              </td>

                              {/* CATEGORY */}
                              <td>{getCategoryName(user.category_id)}</td>

                              {/* SUBCATEGORY */}
                              <td>{getSubCategoryName(user.subcategory_id) || "N/A"}</td>

                              {/* <td>{user.current_price}</td>
                              <td>{user.old_price || "-"}</td>

                              <td>
                                <span className="text-dark fw-medium">
                                  {user.stock} Items
                                </span>
                              </td>

                              <td>{user.rating || "-"}</td>
                              <td>{user.assign_vendor || "-"}</td> */}

                              {/* STATUS FIXED */}
                              {/* <td>
                                <span className={`badge ${statusData.css} py-1 px-2`}>
                                  {statusData.text}
                                </span>
                              </td> */}

                              {/* Admin Approval */}
                              <td>
                                {user.admin_approval === "approval" || user.admin_approval === "yes" ? (
                                  <span className="badge bg-success">Approved</span>
                                ) : user.admin_approval === "rejected" ? (
                                  <span className="badge bg-danger">Rejected</span>
                                ) : (
                                  <span className="badge bg-warning text-dark">Pending</span>
                                )}
                              </td>


                              {/* ACTION BUTTONS */}
                              <td>
                                <div className="d-flex gap-2">
                                  {/* If rejected */}
                                  {user.admin_approval === "rejected" && (
                                    <>
                                      <button
  className="btn btn-warning btn-sm"
  onClick={() => {
    setSelectedProductId(user.product_id);
    setShowReapplyModal(true);
  }}
>
  Reapply
</button>


                                      <button
                                        className="btn btn-info btn-sm"
                                        onClick={() => openReasonModal(user.reason)}
                                      >
                                        View Reason
                                      </button>
                                    </>
                                  )}

                                  {/* If approved */}
                                  {(user.admin_approval === "approval" || user.admin_approval === "yes") && (
                                    <span className="text-success fw-medium">Approved</span>
                                  )}

                                  {/* If pending */}
                                  {!user.admin_approval && (
                                    <span className="text-muted">Waiting for approval</span>
                                  )}
                                </div>
                              </td>

                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="12" className="text-center py-3">
                            No Products Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              {showReasonModal && (
                <div className="modal fade show d-block custom-modal-overlay" tabIndex="-1">
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title fw-semibold">Rejection Reason</h5>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={closeReasonModal}
                        ></button>
                      </div>

                      <div className="modal-body">
                        <div className="mb-3">
                          <label className="form-label">Reason</label>
                          <textarea
                            className="form-control"
                            rows="4"
                            value={selectedReason}
                            readOnly
                          ></textarea>
                        </div>
                      </div>

                      <div className="modal-footer bg-light">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={closeReasonModal}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {showReapplyModal && (
  <div className="modal fade show d-block custom-modal-overlay" tabIndex="-1">
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">

        <div className="modal-header">
          <h5 className="modal-title fw-semibold">Reapply Product</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setShowReapplyModal(false)}
          ></button>
        </div>

        <div className="modal-body">
          <div className="alert alert-warning">
            <strong>Important:</strong>
            <ul className="mb-0 mt-2">
              <li>Update product details as per admin feedback</li>
              <li>Images, pricing & description should be accurate</li>
              <li>Once reapplied, product goes for admin review</li>
            </ul>
          </div>
        </div>

        <div className="modal-footer">
          <button
            className="btn btn-secondary"
            onClick={() => setShowReapplyModal(false)}
          >
            Cancel
          </button>

          <button
            className="btn btn-warning"
            onClick={() => {
              handleReapply(selectedProductId);
              setShowReapplyModal(false);
            }}
          >
            Yes, Reapply
          </button>
        </div>

      </div>
    </div>
  </div>
)}



              {/* PAGINATION */}
              <div className="card-footer border-top">
                <nav aria-label="Page navigation example">
                  <ul className="pagination justify-content-end mb-0">
                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                      <span className="page-link" onClick={() => paginate(currentPage - 1)}>
                        Previous
                      </span>
                    </li>

                    {[...Array(totalPages)].map((_, index) => (
                      <li
                        key={index}
                        className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                      >
                        <span className="page-link" onClick={() => paginate(index + 1)}>
                          {index + 1}
                        </span>
                      </li>
                    ))}

                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                      <span className="page-link" onClick={() => paginate(currentPage + 1)}>
                        Next
                      </span>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              © Venton. Crafted by{" "}
              <iconify-icon
                icon="iconamoon:heart-duotone"
                className="fs-18 align-middle text-danger"
              />{" "}
              <Link to="#" className="fw-bold footer-text" target="_blank">
                Techzaa
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

